import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { PaymentService } from '../../services/payment.service';
import { ApplicationPayment, PaymentSearchCriteria } from '../../models/paymentItem.model';
import { Observable, Subscription, of, BehaviorSubject } from "rxjs";
import { map, switchMap, finalize } from 'rxjs/operators';
import { DocumentManagementService } from '../../../common/services/document-management.service';
import { parseFileNameFromHeaders } from "../../../common/models/onBaseIntegrationAndMapping.model";
import { AuthService } from "../../../services/auth.service";
import { SubHeaderService } from "../../../core/services/sub-header.service";
import { SubHeader } from "../../../core/models/sub-header.model";

@Component({
    selector: 'payment-invoice',
    templateUrl: './payment-invoice.component.html',
    styleUrls: ['./payment-invoice.component.scss'],
    standalone: false
})
export class PaymentInvoiceComponent implements OnInit, OnDestroy {
    data$: Observable<ApplicationPayment>;
    private loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    payment: ApplicationPayment;

    get paymentLoading(): boolean {
        return this.loading$.value;
    }

    get token(): string {
        if (this.payment == null || this.payment.paymentRecords == null || this.payment.paymentRecords.length == 0) return "";
        let tokenString = "";
        this.payment.paymentRecords.forEach(r => {
            if (tokenString.length > 0) tokenString = `${tokenString}, <br /> `;
            tokenString = `${tokenString}${r.token}`;
        })
        return tokenString;
    }

    subscription: Subscription = new Subscription();

    constructor(
        public _activatedRoute: ActivatedRoute,
        public _paymentService: PaymentService,
        public _documentService: DocumentManagementService,
        private _auth: AuthService,
        private _subheaderService: SubHeaderService
    ) {
       
    }

    ngOnInit() {
        this._subheaderService.updateSubHeader(new SubHeader({ title: "Payment Details" }));
        this.data$ = this._activatedRoute.paramMap.pipe(
            switchMap((map: any) => {
                let spec: PaymentSearchCriteria = new PaymentSearchCriteria(this._auth.User.organizationId, "", [], []);
                spec.id = map.get('id');
                return this._paymentService.search(spec);
            }),
            map((results: ApplicationPayment[]) => {
                if (results != null && results.length > 0) this.payment = results[0];
                return this.payment;
            })
        );
        let route$ = this.data$.subscribe(
            () => { this.loading$.next(false); },
            (error) => { console.error(error); }
        );
        this.subscription.add(route$);
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    download() {
        const link = document.createElement("a");
        let obs$: Observable<HttpResponse<Blob>> = of(null);
        if (this.payment.receipt != null) {
            obs$ = this._documentService.downloadFromQueue(this.payment.receipt);
        } else if (this.payment.invoice != null) {
            obs$ = this._documentService.downloadFromQueue(this.payment.invoice);
        } else if (this.payment.queuedReceipt != null) {
            obs$ = this._documentService.downloadFromQueue(this.payment.queuedReceipt);
        } else if (this.payment.queuedInvoice != null) {
            obs$ = this._documentService.downloadFromQueue(this.payment.queuedInvoice);
        }
        let download$ = obs$.subscribe(
            (data) => {
                if (data != null) {
                    const fileName = parseFileNameFromHeaders(data.headers.get("content-disposition"));
                    const blob = new Blob([data.body], { type: data.body.type });
					const blobUri = window.URL.createObjectURL(blob);
					link.href = blobUri;
					link.download = fileName;
					link.click();
                }
            },
            (error) => {
                console.error(error);
            }
        );
        this.subscription.add(download$);
    }

    
}
